<div class="dialog-container">
  <div class="popup-loader-container" *ngIf="loading">
    <div
      class="inner-container uk-flex uk-flex-nowrap uk-flex-center uk-flex-middle"
    >
      <img src="/assets/images/loader.gif" alt="" />
    </div>
  </div>
  <div class="header">
    <p class="white inline-block">
      <b> Verify Two Factor Auth </b>
    </p>
  </div>
  <div class="content">
    <form action="" [formGroup]="form" (ngSubmit)="submit()" ngNativeValidate>
      <p class="tfa-warning-msg">
        We've sent an SMS text with a security code.
        <br />
        Please insert it below.
      </p>
      <div class="input-containers margin-top-10">
        <div class="inputs">
          <div class="input-container">
            <input
              type="text"
              formControlName="token"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              required
            />
            <div class="label grey">Verification Code*</div>
            <div class="error">
              <div *ngIf="form.controls.token.errors && form.controls.token.touched">
                {{ errorManager.ERRORS.security_code_required }}
              </div>
              <div>
                {{ verifyTokenErr }}
              </div>
            </div>
          </div>
          <div class="tfa-resend-token">
            <div>
              <span (click)="sendTFA();" *ngIf="!showTFATimer">
                {{ errorManager.ERRORS.resend_security_code }}
              </span>
              <span *ngIf="showTFATimer">
                {{ errorManager.ERRORS.request_another_code }}
              </span>
            </div>
            <div *ngIf="tokenWasSuccessfulySend">
              <p>
                Security code was successfuly send!
              </p>
            </div>
          </div>
          <div class="input-container uk-text-center">
            <button
              class="uk-button uk-button-primary uk-button-thin savebutton"
              type="submit"
            >
              Verify
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
